import Rotate90DegreesCcwIcon from '@mui/icons-material/Rotate90DegreesCcw'
import Rotate90DegreesCwIcon from '@mui/icons-material/Rotate90DegreesCw'
import { Box, Button, IconButton, Stack } from '@mui/material'
import DialogConfirm from 'components/Dialogs/DialogConfirm'
import { useRef, useState } from 'react'
import {
  loadCanvasAndResize,
  loadCanvasToCanvas90Deg,
  loadCanvasToCanvasMinus90Deg,
  loadImageProcessToCanvas,
} from 'utils/imageConvert'
interface Props {
  setImage: (imageCanvas: HTMLCanvasElement) => void
}

export default function UploadImage({ setImage }: Props) {
  const inputRef = useRef({} as HTMLInputElement)
  const [uploadImg, setUploadImg] = useState<HTMLCanvasElement>()
  const handleConfirm = () => {
    if (uploadImg) {
      setImage(uploadImg)
      setUploadImg(undefined)
    }
  }
  return uploadImg ? (
    <DialogConfirm
      open={!!uploadImg}
      maxWidth="sm"
      handleClose={() => setUploadImg(undefined)}
      handleSubmit={handleConfirm}
      title="画像の確認"
      primaryButtonText="確定する"
    >
      <img
        width="100%"
        src={uploadImg.toDataURL()}
        alt="画像"
        style={{
          border: '1px solid #999',
        }}
      ></img>
      <Box display="flex" justifyContent="center">
        <IconButton
          color="primary"
          size="large"
          onClick={async () => {
            const newImg = await loadCanvasToCanvasMinus90Deg(uploadImg)
            setUploadImg(await loadCanvasAndResize(newImg))
          }}
        >
          <Rotate90DegreesCcwIcon fontSize="inherit" />
        </IconButton>
        <IconButton
          color="primary"
          size="large"
          onClick={async () => {
            const newImg = await loadCanvasToCanvas90Deg(uploadImg)
            setUploadImg(await loadCanvasAndResize(newImg))
          }}
        >
          <Rotate90DegreesCwIcon fontSize="inherit" />
        </IconButton>
      </Box>
    </DialogConfirm>
  ) : (
    <Stack my={2}>
      <input
        ref={inputRef}
        accept="image/*"
        style={{ display: 'none' }}
        id="upload-file"
        type="file"
        onChange={async (e) => {
          if (e.target.files) {
            setUploadImg(await loadImageProcessToCanvas(e.target.files[0]))
          }
        }}
      />
      <label htmlFor="upload-file" style={{ width: 'max-content' }}>
        <Button
          variant="contained"
          component="span"
          size="small"
          color="secondary"
        >
          画像のアップロード
        </Button>
      </label>
    </Stack>
  )
}
